import * as AWS from '@aws-sdk/client-s3'

const region = 'us-east-1'
const bucket = 'f4c-documents'
// const bucket = 'f4c-test-documents'

const client = new AWS.S3({
  region,
  credentials: {
    secretAccessKey: 'MOCK',
    accessKeyId: 'MOCK'
  },
  signer: {
    async sign (request) {
      return request
    }
  }
})

export const s3ListKeys = async prefix => {
  const params = { Bucket: bucket, Prefix: prefix }
  console.log('S3 ListKeys >', bucket, prefix)
  try {
    const response = await client.listObjectsV2(params)
    console.log('S3 ListKeys <', response.Contents ?? response)
    return response.Contents
  } catch (error) {
    console.error('s3-api.js listKeys', error)
  }
}

export const readFile = async key => {
  const params = { Bucket: bucket, Key: key }
  console.log('S3 ReadFile >', bucket, key)
  const response = await client.getObject(params)
  const content = await response.Body.transformToByteArray()
  console.log('S3 ReadFile <', content?.length, 'B')
  return content
}
